import * as svgs from 'assets';
import {Framework, TechStack} from 'components';

const techStacks: TechStack[] = [
  {
    id: 1,
    Icon: svgs['JavascriptSvg'],
    name: 'JS',
    content:
      'JavaScript is one of my strongest foundations as a software engineer. I use it confidently across frontend, backend, tooling, and browser-level problem solving, and it is still the language I trust most when I need to build fast without sacrificing structure.',
    work_exp: 6,
    framework: Framework.Javascript,
    colors: ['rgba(252, 228, 69, 1)', 'rgba(252, 228, 69, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 20},
      {date: new Date(2017, 0, 0), value: 5},
      {date: new Date(2018, 0, 0), value: 5},
      {date: new Date(2019, 0, 0), value: 40},
      {date: new Date(2020, 0, 0), value: 60},
      {date: new Date(2021, 0, 0), value: 80},
      {date: new Date(2022, 0, 0), value: 100},
      {date: new Date(2023, 0, 0), value: 100},
      {date: new Date(2024, 0, 0), value: 100},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 2,
    Icon: svgs['TypescriptSvg'],
    name: 'TS',
    content:
      'TypeScript became one of my core strengths the moment my projects grew in size and complexity. I rely on it to design safer APIs, cleaner contracts, and more maintainable codebases, especially in production systems where correctness and readability matter.',
    work_exp: 5,
    framework: Framework.Javascript,
    colors: ['rgba(0, 153, 255, 1)', 'rgba(0, 153, 255, 0.4)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 15},
      {date: new Date(2021, 0, 0), value: 20},
      {date: new Date(2022, 0, 0), value: 80},
      {date: new Date(2023, 0, 0), value: 90},
      {date: new Date(2024, 0, 0), value: 100},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 3,
    Icon: svgs['NodeSvg'],
    name: 'NodeJS',
    content:
      'NodeJS is one of the runtimes I know best and one of the reasons I can move comfortably between frontend and backend work. I use it not only to build servers and tooling, but also to shape reliable architectures around JavaScript ecosystems.',
    work_exp: 6,
    framework: Framework.Javascript,
    colors: ['rgba(65, 135, 63, 1)', 'rgba(65, 135, 63, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 15},
      {date: new Date(2020, 0, 0), value: 20},
      {date: new Date(2021, 0, 0), value: 40},
      {date: new Date(2022, 0, 0), value: 40},
      {date: new Date(2023, 0, 0), value: 65},
      {date: new Date(2024, 0, 0), value: 80},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 3,
    Icon: svgs['NestjsSvg'],
    name: 'NestJS',
    content:
      'NestJS is one of the newer additions to my stack, so I am still building deeper practical experience with it. What I like most so far is its strong structure, modular architecture, and the way it encourages maintainable backend design from the start.',
    work_exp: 1,
    framework: Framework.Javascript,
    colors: ['rgba(232, 3, 60, 1)', 'rgba(230, 29, 100, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 0},
      {date: new Date(2023, 0, 0), value: 0},
      {date: new Date(2024, 0, 0), value: 60},
      {date: new Date(2025, 0, 0), value: 80},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 5,
    Icon: svgs['ExpressSvg'],
    name: 'Express',
    content:
      'Express is one of the backend technologies that helped shape my full stack foundation. I have used it enough to be confident with API design, middleware patterns, service structure, and the practical tradeoffs involved in building lightweight backend systems.',
    work_exp: 3,
    framework: Framework.Javascript,
    colors: ['rgba(0, 0, 0, 1)', 'rgba(0, 0, 0, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 10},
      {date: new Date(2019, 0, 0), value: 60},
      {date: new Date(2020, 0, 0), value: 100},
      {date: new Date(2021, 0, 0), value: 50},
      {date: new Date(2022, 0, 0), value: 60},
      {date: new Date(2023, 0, 0), value: 40},
      {date: new Date(2024, 0, 0), value: 80},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 6,
    Icon: svgs['WebpackSvg'],
    name: 'Webpack',
    content:
      'Webpack is one of my forte tools when it comes to build pipelines and project architecture. I enjoy working close to the bundler layer because it gives me full control over how an application is assembled, optimized, and prepared for different environments.',
    work_exp: 4,
    framework: Framework.Javascript,
    colors: ['rgba(0, 124, 219, 1)', 'rgba(0, 124, 219, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 7.5},
      {date: new Date(2020, 0, 0), value: 15},
      {date: new Date(2021, 0, 0), value: 50},
      {date: new Date(2022, 0, 0), value: 60},
      {date: new Date(2023, 0, 0), value: 60},
      {date: new Date(2024, 0, 0), value: 100},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 7,
    Icon: svgs['ReactSvg'],
    name: 'React',
    content:
      'React is one of my strongest frontend technologies and one of the stacks where I feel most at home. I use it confidently for component architecture, state flow, UI behavior, and designing interfaces that stay maintainable even as the application grows.',
    work_exp: 5,
    framework: Framework.Javascript,
    colors: ['rgba(77, 216, 255, 1)', 'rgba(77, 216, 255, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 75},
      {date: new Date(2021, 0, 0), value: 90},
      {date: new Date(2022, 0, 0), value: 100},
      {date: new Date(2023, 0, 0), value: 100},
      {date: new Date(2024, 0, 0), value: 100},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 8,
    Icon: svgs['ReduxSvg'],
    name: 'Redux',
    content:
      'Redux is one of the state management tools I know deeply and use with confidence in complex applications. I am comfortable designing stores, separating concerns, and keeping application state predictable when the UI and business logic become large.',
    work_exp: 4,
    framework: Framework.Javascript,
    colors: ['rgba(98, 0, 255, 1)', 'rgba(98, 0, 255, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 50},
      {date: new Date(2021, 0, 0), value: 80},
      {date: new Date(2022, 0, 0), value: 100},
      {date: new Date(2023, 0, 0), value: 100},
      {date: new Date(2024, 0, 0), value: 100},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 9,
    Icon: svgs['ReduxSagaSvg'],
    name: 'Redux Saga',
    content:
      'Redux Saga is part of my forte stack whenever I need clean orchestration for side effects and asynchronous flows. I like how it helps organize complex behavior in a readable way, especially in applications where timing, events, and coordination matter.',
    work_exp: 3,
    framework: Framework.Javascript,
    colors: ['rgba(120, 255, 71, 1)', 'rgba(120, 255, 71, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 25},
      {date: new Date(2021, 0, 0), value: 50},
      {date: new Date(2022, 0, 0), value: 70},
      {date: new Date(2023, 0, 0), value: 80},
      {date: new Date(2024, 0, 0), value: 100},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 10,
    Icon: svgs['VueSvg'],
    name: 'Vue',
    content:
      'Vue is another frontend framework I can work with confidently and comfortably in real projects. I appreciate its flexibility, its evolving patterns, and how naturally it supports building clean component structures without losing development speed.',
    work_exp: 2,
    framework: Framework.Javascript,
    colors: ['rgba(65, 148, 50, 1)', 'rgba(65, 148, 50, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 10},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 20},
      {date: new Date(2023, 0, 0), value: 60},
      {date: new Date(2024, 0, 0), value: 20},
      {date: new Date(2025, 0, 0), value: 40},
      {date: new Date(2026, 0, 0), value: 40}
    ]
  },
  {
    id: 11,
    Icon: svgs['AngularSvg'],
    name: 'Angular',
    content:
      'Angular is still a newer technology in my stack, so I treat it as an active growth area rather than one of my strongest frameworks yet. I am interested in its opinionated structure and enterprise-oriented patterns, and I want to deepen my practical experience with it.',
    work_exp: 1.5,
    framework: Framework.Javascript,
    colors: ['rgba(255, 68, 215, 0.47)', 'rgba(131, 20, 200, 0.49)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 20},
      {date: new Date(2023, 0, 0), value: 0},
      {date: new Date(2024, 0, 0), value: 40},
      {date: new Date(2025, 0, 0), value: 80},
      {date: new Date(2026, 0, 0), value: 20}
    ]
  },
  {
    id: 12,
    Icon: svgs['PythonSvg'],
    name: 'Python',
    content:
      'Python is one of my core backend languages and one of the technologies I use with strong confidence. I value it for its clarity, speed of development, and flexibility, especially when building services, integrations, and systems that need to move fast without becoming messy.',
    work_exp: 4,
    framework: Framework.Python,
    colors: ['rgba(55, 115, 165, 1)', 'rgba(198, 147, 17, 0.3)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 10},
      {date: new Date(2017, 0, 0), value: 5},
      {date: new Date(2018, 0, 0), value: 5},
      {date: new Date(2019, 0, 0), value: 20},
      {date: new Date(2020, 0, 0), value: 50},
      {date: new Date(2021, 0, 0), value: 30},
      {date: new Date(2022, 0, 0), value: 50},
      {date: new Date(2023, 0, 0), value: 20},
      {date: new Date(2024, 0, 0), value: 70},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 13,
    Icon: svgs['FlaskSvg'],
    name: 'Flask',
    content:
      'Flask is one of the Python frameworks I know well enough to use confidently in real backend work. I like its lightweight nature because it gives me room to design the architecture myself while still moving quickly when building APIs and service layers.',
    work_exp: 2,
    framework: Framework.Python,
    colors: ['rgba(0, 43, 0, 1)', 'rgba(0, 43, 0, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 80},
      {date: new Date(2023, 0, 0), value: 60},
      {date: new Date(2024, 0, 0), value: 0},
      {date: new Date(2025, 0, 0), value: 0},
      {date: new Date(2026, 0, 0), value: 0}
    ]
  },
  {
    id: 14,
    Icon: svgs['FastApiSvg'],
    name: 'FastAPI',
    content:
      'FastAPI is one of the Python frameworks I consider part of my stronger backend toolkit today. I like how it balances speed, structure, typing, and developer experience, especially for APIs where clarity and performance both matter.',
    work_exp: 2,
    framework: Framework.Python,
    colors: ['rgba(0, 148, 133, 1)', 'rgba(0, 148, 133, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 25},
      {date: new Date(2022, 0, 0), value: 0},
      {date: new Date(2023, 0, 0), value: 80},
      {date: new Date(2024, 0, 0), value: 20},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 15,
    Icon: svgs['DjangoSvg'],
    name: 'DJango',
    content:
      'Django is part of the backend stack I can work with confidently when the project benefits from an opinionated framework. I appreciate how much it provides out of the box, especially when the goal is to move fast with conventions that already support scale and maintainability.',
    work_exp: 1.5,
    framework: Framework.Python,
    colors: ['rgba(43, 169, 119, 1)', 'rgba(43, 169, 119, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 0},
      {date: new Date(2023, 0, 0), value: 80},
      {date: new Date(2024, 0, 0), value: 40},
      {date: new Date(2025, 0, 0), value: 0},
      {date: new Date(2026, 0, 0), value: 0}
    ]
  },
  {
    id: 16,
    Icon: svgs['GoogleAdkSvg'],
    name: 'GoogleADK',
    content:
      'GoogleADK is a recent addition to my stack, so I am still in the stage of exploring its best practices and practical use cases. I see strong potential in it, and I am intentionally building familiarity before I consider it part of my deeper forte set.',
    work_exp: 1,
    framework: Framework.Python,
    colors: ['rgba(214, 191, 40, 1)', 'rgba(208, 57, 57, 0.52)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 0},
      {date: new Date(2023, 0, 0), value: 0},
      {date: new Date(2024, 0, 0), value: 0},
      {date: new Date(2025, 0, 0), value: 40},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 17,
    Icon: svgs['StrandsSvg'],
    name: 'Strands',
    content:
      'Strands is also one of the newer technologies I have added to my learning path. I am still gaining hands-on depth with it, but I am interested in how it can fit into modern AI-oriented workflows and more composable system design.',
    work_exp: 1,
    framework: Framework.Python,
    colors: ['rgba(43, 188, 79, 1)', 'rgba(0, 0, 0, 0.65)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 0},
      {date: new Date(2023, 0, 0), value: 0},
      {date: new Date(2024, 0, 0), value: 0},
      {date: new Date(2025, 0, 0), value: 40},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 18,
    Icon: svgs['PostgresqlSvg'],
    name: 'PostgreSQL',
    content:
      'PostgreSQL is one of my strongest database technologies and the relational database I trust most for serious application work. I like its balance of structure, reliability, extensibility, and the way it supports disciplined data modeling in real systems.',
    work_exp: 5,
    framework: Framework.Database,
    colors: ['rgba(49, 100, 140, 1)', 'rgba(49, 100, 140, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 25},
      {date: new Date(2018, 0, 0), value: 10},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 25},
      {date: new Date(2021, 0, 0), value: 75},
      {date: new Date(2022, 0, 0), value: 80},
      {date: new Date(2023, 0, 0), value: 80},
      {date: new Date(2024, 0, 0), value: 80},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 10}
    ]
  },
  {
    id: 19,
    Icon: svgs['MysqlSvg'],
    name: 'MySQL',
    content:
      'MySQL is currently a newer database in my stack, so I do not present it yet as one of my deepest strengths. I understand where it fits well, and I am continuing to build more practical experience around its workflows and operational patterns.',
    work_exp: 1,
    framework: Framework.Database,
    colors: ['rgba(28, 92, 176, 0.52)', 'rgba(0, 0, 0, 0.47)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 0},
      {date: new Date(2023, 0, 0), value: 40},
      {date: new Date(2024, 0, 0), value: 80},
      {date: new Date(2025, 0, 0), value: 50},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 20,
    Icon: svgs['PineconeSvg'],
    name: 'Pinecone',
    content:
      'Pinecone is still a newer tool in my stack and one that I am approaching as an active learning area. I am interested in how it supports modern retrieval and AI applications, but I am still building stronger hands-on depth with it.',
    work_exp: 1,
    framework: Framework.Database,
    colors: ['rgba(0, 0, 0, 1)', 'rgba(0, 0, 0, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 0},
      {date: new Date(2023, 0, 0), value: 0},
      {date: new Date(2024, 0, 0), value: 0},
      {date: new Date(2025, 0, 0), value: 0},
      {date: new Date(2026, 0, 0), value: 80}
    ]
  },
  {
    id: 21,
    Icon: svgs['MongoSvg'],
    name: 'MongoDB',
    content:
      'MongoDB is one of the databases I can work with confidently when a document-oriented model makes more sense than a relational design. I usually reach for it in cases where schema flexibility, event-heavy flows, or service-specific data patterns are the better fit.',
    work_exp: 2,
    framework: Framework.Database,
    colors: ['rgba(65, 148, 50, 1)', 'rgba(65, 148, 50, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 0},
      {date: new Date(2023, 0, 0), value: 40},
      {date: new Date(2024, 0, 0), value: 60},
      {date: new Date(2025, 0, 0), value: 0},
      {date: new Date(2026, 0, 0), value: 0}
    ]
  },
  {
    id: 22,
    Icon: svgs['HtmlSvg'],
    name: 'HTML',
    content:
      'HTML is part of my core frontend foundation and one of the technologies I treat as second nature. I care about semantic structure, accessibility, and creating markup that supports clean styling, predictable behavior, and maintainable interfaces.',
    work_exp: 5,
    framework: Framework.MarkupLanguage,
    colors: ['rgba(255, 63, 10, 1)', 'rgba(255, 63, 10, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 30},
      {date: new Date(2017, 0, 0), value: 80},
      {date: new Date(2018, 0, 0), value: 5},
      {date: new Date(2019, 0, 0), value: 5},
      {date: new Date(2020, 0, 0), value: 25},
      {date: new Date(2021, 0, 0), value: 80},
      {date: new Date(2022, 0, 0), value: 90},
      {date: new Date(2023, 0, 0), value: 90},
      {date: new Date(2024, 0, 0), value: 100},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 23,
    Icon: svgs['CssSvg'],
    name: 'CSS',
    content:
      'CSS is absolutely one of my forte areas and one of the places where I enjoy craftsmanship the most. I like building polished interfaces, expressive layouts, and detailed UI behavior, and I am patient enough to turn design ideas into production-quality implementation.',
    work_exp: 5,
    framework: Framework.StyleSheet,
    colors: ['rgba(0, 118, 214, 1)', 'rgba(0, 118, 214, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 20},
      {date: new Date(2017, 0, 0), value: 5},
      {date: new Date(2018, 0, 0), value: 5},
      {date: new Date(2019, 0, 0), value: 20},
      {date: new Date(2020, 0, 0), value: 70},
      {date: new Date(2021, 0, 0), value: 90},
      {date: new Date(2022, 0, 0), value: 100},
      {date: new Date(2023, 0, 0), value: 100},
      {date: new Date(2024, 0, 0), value: 100},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 24,
    Icon: svgs['NpmSvg'],
    name: 'NPM',
    content:
      'NPM is part of the tooling ecosystem I work with confidently on a regular basis. Beyond just installing packages, I think about dependency design, reusable utilities, scripts, and how package-based workflows support faster and cleaner engineering.',
    work_exp: 2.5,
    framework: Framework.Infra,
    colors: ['rgba(199, 34, 39, 1)', 'rgba(199, 34, 39, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 20},
      {date: new Date(2021, 0, 0), value: 20},
      {date: new Date(2022, 0, 0), value: 20},
      {date: new Date(2023, 0, 0), value: 40},
      {date: new Date(2024, 0, 0), value: 100},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 25,
    Icon: svgs['GraphqlSvg'],
    name: 'GraphQL',
    content:
      'GraphQL is now part of the stack I can approach with much more confidence than before. I understand its value in shaping flexible client-server contracts, and I appreciate the level of control it gives when designing data access patterns for modern applications.',
    work_exp: 1.5,
    framework: Framework.QL,
    colors: ['rgba(212, 1, 111, 1)', 'rgba(212, 1, 111, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 15},
      {date: new Date(2023, 0, 0), value: 60},
      {date: new Date(2024, 0, 0), value: 60},
      {date: new Date(2025, 0, 0), value: 80},
      {date: new Date(2026, 0, 0), value: 40}
    ]
  },
  {
    id: 26,
    Icon: svgs['WebsocketSvg'],
    name: 'Websocket',
    content:
      'Websocket is one of the real-time technologies I understand well enough to treat as part of my stronger backend toolbox. I am comfortable with connection lifecycles, event-driven communication, and the architectural thinking required to keep realtime flows reliable.',
    work_exp: 1,
    framework: Framework.Javascript,
    colors: ['rgba(159, 16, 16, 0.8)', 'rgba(167, 88, 24, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 0},
      {date: new Date(2023, 0, 0), value: 0},
      {date: new Date(2024, 0, 0), value: 80},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 27,
    Icon: svgs['GitSvg'],
    name: 'GIT',
    content:
      'Git is one of the tools I use most naturally in day-to-day engineering work. Version control is not just a utility for me anymore, it is part of how I structure collaboration, protect delivery flow, and keep development history clean and intentional.',
    work_exp: 5,
    framework: Framework.VersionCtrl,
    colors: ['rgba(255, 52, 20, 1)', 'rgba(255, 52, 20, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 50},
      {date: new Date(2020, 0, 0), value: 50},
      {date: new Date(2021, 0, 0), value: 90},
      {date: new Date(2022, 0, 0), value: 80},
      {date: new Date(2023, 0, 0), value: 100},
      {date: new Date(2024, 0, 0), value: 100},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 28,
    Icon: svgs['GithubSvg'],
    name: 'Github',
    content:
      'Github is one of the repository platforms I know best and use confidently for both individual and team workflows. I rely on it not only for source control, but also for reviews, automation, collaboration patterns, and keeping project movement visible.',
    work_exp: 5,
    framework: Framework.WebbasedRepo,
    colors: ['rgba(0, 0, 0, 1)', 'rgba(0, 0, 0, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 25},
      {date: new Date(2018, 0, 0), value: 40},
      {date: new Date(2019, 0, 0), value: 30},
      {date: new Date(2020, 0, 0), value: 40},
      {date: new Date(2021, 0, 0), value: 50},
      {date: new Date(2022, 0, 0), value: 90},
      {date: new Date(2023, 0, 0), value: 80},
      {date: new Date(2024, 0, 0), value: 80},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 29,
    Icon: svgs['GitlabSvg'],
    name: 'Gitlab',
    content:
      'Gitlab is another platform I can work with comfortably when a project or team uses it as the main delivery hub. I understand its collaboration model well enough to manage repositories, pipelines, team workflows, and structured development processes inside it.',
    work_exp: 4,
    framework: Framework.WebbasedRepo,
    colors: ['rgba(226, 67, 41, 1)', 'rgba(226, 67, 41, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 25},
      {date: new Date(2019, 0, 0), value: 25},
      {date: new Date(2020, 0, 0), value: 10},
      {date: new Date(2021, 0, 0), value: 50},
      {date: new Date(2022, 0, 0), value: 90},
      {date: new Date(2023, 0, 0), value: 80},
      {date: new Date(2024, 0, 0), value: 30},
      {date: new Date(2025, 0, 0), value: 20},
      {date: new Date(2026, 0, 0), value: 20}
    ]
  },
  {
    id: 30,
    Icon: svgs['AtlassianSvg'],
    name: 'Atlassian',
    content:
      'Atlassian tools are part of the collaboration stack I use confidently in professional work. I am comfortable with the way they support planning, documentation, backlog visibility, and the communication structure needed to keep teams aligned.',
    work_exp: 3,
    framework: Framework.WebbasedRepo,
    colors: ['rgba(0, 82, 204, 1)', 'rgba(0, 82, 204, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 40},
      {date: new Date(2022, 0, 0), value: 30},
      {date: new Date(2023, 0, 0), value: 70},
      {date: new Date(2024, 0, 0), value: 90},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 31,
    Icon: svgs['KubernetesSvg'],
    name: 'Kubernetes',
    content:
      'Kubernetes is part of the infrastructure space where I have built solid practical confidence over time. I appreciate it because it pushes me to think in systems, services, deployment strategy, and operational consistency rather than just individual applications.',
    work_exp: 1,
    framework: Framework.Infra,
    colors: ['rgba(50, 109, 230, 1)', 'rgba(50, 109, 230, 0.2)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 5},
      {date: new Date(2023, 0, 0), value: 50},
      {date: new Date(2024, 0, 0), value: 50},
      {date: new Date(2025, 0, 0), value: 80},
      {date: new Date(2026, 0, 0), value: 60}
    ]
  },
  {
    id: 32,
    Icon: svgs['DockerSvg'],
    name: 'Docker',
    content:
      'Docker is one of the infrastructure tools I use with strong confidence in development and deployment workflows. I value it for making environments reproducible, isolating services clearly, and helping me ship systems in a way that is easier to reason about.',
    work_exp: 2.5,
    framework: Framework.CICD,
    colors: ['rgba(0, 106, 128, 1)', 'rgba(0, 106, 128, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 10},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 10},
      {date: new Date(2022, 0, 0), value: 80},
      {date: new Date(2023, 0, 0), value: 100},
      {date: new Date(2024, 0, 0), value: 80},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 33,
    Icon: svgs['JenkinsSvg'],
    name: 'Jenkins',
    content:
      'Jenkins is one of the automation tools I can use confidently when a project needs flexible CI or deployment workflows. I like that it gives enough control to shape pipelines around the actual engineering process instead of forcing a narrow path.',
    work_exp: 1,
    framework: Framework.WebbasedRepo,
    colors: ['rgba(199, 34, 39, 1)', 'rgba(199, 34, 39, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 0},
      {date: new Date(2023, 0, 0), value: 0},
      {date: new Date(2024, 0, 0), value: 80},
      {date: new Date(2025, 0, 0), value: 40},
      {date: new Date(2026, 0, 0), value: 80}
    ]
  },
  {
    id: 34,
    Icon: svgs['CircleCISvg'],
    name: 'CircleCI',
    content:
      'CircleCI is part of the CI/CD tooling I know well enough to use confidently in real projects. I am comfortable building pipelines, wiring automated checks, and using it as part of a dependable release process.',
    work_exp: 2,
    framework: Framework.WebbasedRepo,
    colors: ['rgba(0, 0, 0, 0.5)', 'rgba(0, 0, 0, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 5},
      {date: new Date(2021, 0, 0), value: 50},
      {date: new Date(2022, 0, 0), value: 60},
      {date: new Date(2023, 0, 0), value: 20},
      {date: new Date(2024, 0, 0), value: 5},
      {date: new Date(2025, 0, 0), value: 0},
      {date: new Date(2026, 0, 0), value: 0}
    ]
  },
  {
    id: 35,
    Icon: svgs['AwsSvg'],
    name: 'AWS',
    content:
      'AWS is one of the cloud platforms I treat as a serious working strength today. I continue learning it actively, but I am already confident using it to think about infrastructure, service composition, deployment decisions, and practical production tradeoffs.',
    work_exp: 1.5,
    framework: Framework.Infra,
    colors: ['rgba(255, 153, 0, 1)', 'rgba(255, 153, 0, 0.1)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 25},
      {date: new Date(2022, 0, 0), value: 50},
      {date: new Date(2023, 0, 0), value: 80},
      {date: new Date(2024, 0, 0), value: 50},
      {date: new Date(2025, 0, 0), value: 90},
      {date: new Date(2026, 0, 0), value: 80}
    ]
  },
  {
    id: 36,
    Icon: svgs['LightsailSvg'],
    name: 'LightSail',
    content:
      'LightSail is a newer service in my stack, so I still treat it as an area I am growing into rather than a core forte. I like its simplicity for lightweight deployments, and I want to deepen my experience with where it fits best.',
    work_exp: 1,
    framework: Framework.Infra,
    colors: ['rgba(195, 105, 32, 1)', 'rgba(212, 142, 38, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 0},
      {date: new Date(2023, 0, 0), value: 0},
      {date: new Date(2024, 0, 0), value: 40},
      {date: new Date(2025, 0, 0), value: 20},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  },
  {
    id: 37,
    Icon: svgs['GoogleCloudSvg'],
    name: 'Google Cloud',
    content:
      'Google Cloud is part of the cloud ecosystem I can already work with confidently for practical engineering needs. I have used it in areas that matter to real systems, and I continue building stronger depth around its platform services and operational patterns.',
    work_exp: 1.5,
    framework: Framework.Infra,
    colors: ['rgba(234, 67, 53, 1)', 'rgba(251, 188, 5, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 15},
      {date: new Date(2022, 0, 0), value: 20},
      {date: new Date(2023, 0, 0), value: 30},
      {date: new Date(2024, 0, 0), value: 25},
      {date: new Date(2025, 0, 0), value: 50},
      {date: new Date(2026, 0, 0), value: 80}
    ]
  },
  {
    id: 38,
    Icon: svgs['FirebaseSvg'],
    name: 'Firebase',
    content:
      'Firebase is one of the platforms I can use confidently when the project benefits from fast setup and managed backend capabilities. I understand where it shines, especially for rapid delivery, realtime features, and products that do not need heavy custom infrastructure from day one.',
    work_exp: 2,
    framework: Framework.Infra,
    colors: ['rgba(255, 130, 5, 1)', 'rgba(255, 130, 5, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 20},
      {date: new Date(2019, 0, 0), value: 20},
      {date: new Date(2020, 0, 0), value: 70},
      {date: new Date(2021, 0, 0), value: 80},
      {date: new Date(2022, 0, 0), value: 10},
      {date: new Date(2023, 0, 0), value: 0},
      {date: new Date(2024, 0, 0), value: 0},
      {date: new Date(2025, 0, 0), value: 0},
      {date: new Date(2026, 0, 0), value: 0}
    ]
  },
  {
    id: 39,
    Icon: svgs['JestSvg'],
    name: 'Jest',
    content:
      'Jest is one of the testing tools I am comfortable using as part of a healthy engineering workflow. I see testing not as a checkbox but as a support system for refactoring, confidence, and long-term maintainability, and Jest fits naturally into that mindset.',
    work_exp: 2,
    framework: Framework.Javascript,
    colors: ['rgba(153, 66, 91, 1)', 'rgba(153, 66, 91, 0.5)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 2},
      {date: new Date(2020, 0, 0), value: 10},
      {date: new Date(2021, 0, 0), value: 5},
      {date: new Date(2022, 0, 0), value: 50},
      {date: new Date(2023, 0, 0), value: 40},
      {date: new Date(2024, 0, 0), value: 20},
      {date: new Date(2025, 0, 0), value: 60},
      {date: new Date(2026, 0, 0), value: 40}
    ]
  },
  {
    id: 40,
    Icon: svgs['SeleniumSvg'],
    name: 'Selenium',
    content:
      'Selenium is a newer testing tool in my stack, so I am still building stronger practical depth with it. I understand its importance for browser automation and end-to-end flows, and I am continuing to grow my confidence through hands-on use.',
    work_exp: 1,
    framework: Framework.Javascript,
    colors: ['rgb(65, 202, 35)', 'rgba(126, 222, 16, 0.51)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 0},
      {date: new Date(2023, 0, 0), value: 60},
      {date: new Date(2024, 0, 0), value: 10},
      {date: new Date(2025, 0, 0), value: 100},
      {date: new Date(2026, 0, 0), value: 20}
    ]
  },
  {
    id: 41,
    Icon: svgs['LangfuseSvg'],
    name: 'Langfuse',
    content:
      'Langfuse is one of the newest tools I have added to my stack and one I am still exploring in depth. I am interested in its role in observability for AI workflows, but I still consider it an active learning area rather than a mature forte.',
    work_exp: 1,
    framework: Framework.Infra,
    colors: ['rgb(181, 25, 25)', 'rgba(38, 94, 184, 0.55)'],
    graph: [
      {date: new Date(2016, 0, 0), value: 0},
      {date: new Date(2017, 0, 0), value: 0},
      {date: new Date(2018, 0, 0), value: 0},
      {date: new Date(2019, 0, 0), value: 0},
      {date: new Date(2020, 0, 0), value: 0},
      {date: new Date(2021, 0, 0), value: 0},
      {date: new Date(2022, 0, 0), value: 0},
      {date: new Date(2023, 0, 0), value: 0},
      {date: new Date(2024, 0, 0), value: 0},
      {date: new Date(2025, 0, 0), value: 40},
      {date: new Date(2026, 0, 0), value: 100}
    ]
  }
];

export default techStacks;
